<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { computed, useAttrs } from "vue"
import { cn } from "@/shared/lib/utils"

// inheritAttrs=false: спершу розкладаємо attrs на <input> через v-bind, потім
// явні :aria-invalid/:data-invalid перекривають їх обчисленим значенням, тож
// зовнішній aria-invalid не дублюється і не губиться.
defineOptions({ inheritAttrs: false })

const props = defineProps<{
  /** Помилковий стан. Виставляє aria-invalid + data-invalid → error-токени (border/ring destructive). */
  invalid?: boolean
  class?: HTMLAttributes["class"]
}>()

const model = defineModel<string>({ default: "" })
const attrs = useAttrs()

/** Error-стан = проп `invalid` АБО зовнішній aria-invalid (string/boolean truthy). */
const ariaInvalid = computed<true | undefined>(() => {
  if (props.invalid)
    return true
  const a = attrs["aria-invalid"]
  return a === true || a === "" || a === "true" ? true : undefined
})
</script>

<template>
  <input
    v-bind="attrs"
    v-model="model"
    data-slot="input"
    :aria-invalid="ariaInvalid"
    :data-invalid="ariaInvalid"
    :class="
      cn(
        'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        props.class,
      )
    "
  >
</template>
